import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setCartransfer } from '../api/cartransferService';
import { useCircuitBreaker } from './useCircuitBreaker';

/**
 * Hook para actualizar cartransfers
 */
export function useUpdateCartransfer() {
  const queryClient = useQueryClient();
  const circuitBreaker = useCircuitBreaker(10, 30000); // 10 llamadas, 30 segundos timeout
  
  const mutation = useMutation({
    mutationFn: ({ id, data }) => {
      console.log('useUpdateCartransfer mutationFn called', { id, data });
      return circuitBreaker.execute(setCartransfer, id, data);
    },
    onSuccess: (data, variables) => {
      // Invalidar queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['cartransfers'] });
      // Comentado temporalmente para evitar bucle infinito
      // queryClient.invalidateQueries({ queryKey: ['cartransfer', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      return data;
    },
    onError: (error) => {
      console.error('Error updating cartransfer:', error);
    },
  });

  // Exponer el método reset del circuit breaker
  return {
    ...mutation,
    resetCircuitBreaker: circuitBreaker.reset
  };
} 